import { ProductService } from "@/services/nextshop/product.service";

export default {
  methods: {
    async checkSerialItem(sku, inventoryId) {
      try {
        const params = {
          queryString: "{inventoryId} == '''"+`${inventoryId ? inventoryId : ''}`+"''' and {sku}=='''"+`${sku}`+"''' and {serieStatus}=='''IN_STOCK''' and {isLocked}==false",
          limit: 100,
          lastIndex: ''
        }

        const response = await ProductService.getProductSeriesEmei(params)

        if (response.success) {
          return response.data
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}